module.exports = __webpack_public_path__ + "static/media/hamilton logo.729adc93.png";